// extracted by mini-css-extract-plugin
export default {"navBorder":"index_navBorder_ZrNml","nav_box":"index_nav_box_dsejw","fix_nav_box":"index_fix_nav_box_moZa6","item_box":"index_item_box_t--L6","current_box":"index_current_box_NWMF0"};